export const TOGGLE_MORE_PRODUCT_RETAILERS =
  'BEAMLY/CCX/TOGGLE_MORE_PRODUCT_RETAILERS';
